import { formatIndianNumber } from "app/shared/ReuseComponents/DateFormatter";

export const getDocumentDetails = (workflowName, requests) => {
  switch (workflowName) {
    case "payroll management":
      return {
        additionalFields: [
          { label: "Total Attendance", value: requests?.length || 0 },
          {
            label: "Total Salary",
            value:
              formatIndianNumber(
                requests?.reduce(
                  (sum, opt) =>
                    sum + (opt?.Salary_Details?.This_Month_Salary || 0),
                  0,
                ),
              ) || "0",
          },
        ],
      };

    case "Attandance Management":
      return {
        additionalFields: [
          { label: "Total Employees", value: requests?.length || 0 },
          { label: "Total Attendance", value: requests?.length || 0 },
          { label: "Month", value: requests[0]?.Month || "" },
        ],
      };

    case "TimesheetLog":
      return {
        additionalFields: [
          { label: "Total Timsheets", value: requests?.length || 0 },
          {
            label: "Month",
            value: new Date(requests[0].ToDate).toLocaleString("en-US", {
              month: "long",
            }),
          },
        ],
      };

    default:
      return {
        additionalFields: [
          {
            label: "Request No #",
            value: getRequestNumber(workflowName, requests),
          },
          {
            label: "Initiated by user",
            value: getInitiatorName(workflowName, requests),
          },
        ],
      };
  }
};

const getRequestNumber = (workflowName, requests) => {
  const mapping = {
    Leave: "Application_Id",
    "Leave Cancellation": "Cancellation_Id",
    timesheet: "TimeSheet_Id",
    TimesheetLog: "TimeSheet_Id",
    Reimbursement: "Employeeclaim_Id",
    "Full and Final Settlement": "FullandFinal_Id",
    Resignation: "EmployeeResignation_Id",
  };

  const field = mapping[workflowName];
  return field ? requests?.[field] || "" : "";
};

const getInitiatorName = (workflowName, requests) => {
  // Handle missing requests
  if (!requests) return "";

  // // Payroll Management: requests is an array of objects with Employee_Name
  // if (workflowName === "payroll management") {
  //   // Ensure requests is an array before mapping
  //   if (Array.isArray(requests)) {
  //     return requests
  //       .map((opt) => opt?.Employee_Name)
  //       .filter(Boolean)
  //       .join(", ");
  //   }
  //   return ""; // Return empty if not array
  // }

  // // Full and Final Settlement: requests is a single object with Employee_Name and Employee_Id
  // if (workflowName === "Full and Final Settlement") {
  //   const name = requests?.Employee_Name;
  //   const id = requests?.Employee_Id;
  //   if (name && id) return `${name} - ${id}`;
  //   if (name) return name;
  //   if (id) return id;
  //   return "";
  // }

  // Default: get creator info from Employee_Id or Created_By
  const createdBy = (requests?.Employee_Id && typeof requests.Employee_Id === "object")
    ? requests.Employee_Id
    : requests?.Created_By;
  if (!createdBy) return "";

  // Extract first and last name using possible field names
  const firstName = createdBy.first_name || createdBy.Employee_FirstName || "";
  const lastName = createdBy.last_name || createdBy.Employee_LastName || createdBy.Employee_LasttName || "";

  // Combine and trim to avoid extra spaces
  return `${firstName} ${lastName}`.trim() || "Employee";
};

// newly added on 22-02-2026 by ponkumar
// newly added on 22-02-2026 by ponkumar
// updated on 01-06-2026 to include detailed premium layout and request specifics
export const generateHRApprovalMail = ({ workflowName, latestApproval, requests, isFinal = true }) => {
  console.log("latestApprovallatestApproval", latestApproval);
  const isApproved = latestApproval?.status_btn === "yes";

  const statusColor = isApproved ? "#16a34a" : "#dc2626"; // green / red
  const approverComments = latestApproval?.comments || "";

  const approverRoleOrName = latestApproval?.Approvername || latestApproval?.ApproverRole || "Approver";
  const statusText = isApproved
    ? (isFinal ? "Approved" : `Approved by ${approverRoleOrName}`)
    : "Rejected";

  const approvalMessage = isApproved
    ? (isFinal
        ? `Your request for <strong>${workflowName}</strong> has been <span style="color: ${statusColor}; font-weight: bold;">Approved</span>.`
        : `Your request for <strong>${workflowName}</strong> has been <span style="color: ${statusColor}; font-weight: bold;">Approved by ${approverRoleOrName}</span>.`
      )
    : `Your request for <strong>${workflowName}</strong> has been <span style="color: ${statusColor}; font-weight: bold;">Rejected</span>.`;

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
    } catch (e) {
      return dateStr;
    }
  };

  let detailsHtml = "";

  if (workflowName === "Leave" || workflowName?.toLowerCase() === "leave") {
    const fromStr = requests?.From_Date || "";
    const toStr = requests?.To_Date || "";
    let daysCount = "";
    if (fromStr && toStr) {
      const fromD = new Date(fromStr);
      const toD = new Date(toStr);
      const diffTime = Math.abs(toD - fromD);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
      daysCount = isNaN(diffDays) ? "" : `${diffDays} Day(s)`;
    }

    detailsHtml = `
      <table style="width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 13px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold; width: 35%;">Leave ID</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">${requests?.Application_Id || "-"}</td>
        </tr>
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold;">Leave Type</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">${requests?.Leavetype || requests?.Leavetype_Id?.Leave_Type || requests?.Leavetype_Id?.Name || "-"}</td>
        </tr>
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold;">Leave Period</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">
            ${formatDate(fromStr)} to ${formatDate(toStr)}
            ${daysCount ? ` <span style="color: #6b7280; font-size: 12px; font-weight: normal;">(${daysCount})</span>` : ""}
          </td>
        </tr>
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold; vertical-align: top;">Reason</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937; line-height: 1.4;">${requests?.ReasonOf_Leave || "-"}</td>
        </tr>
      </table>
    `;
  } else if (workflowName === "Leave Cancellation" || workflowName?.toLowerCase() === "leave cancellation") {
    const cancelFromStr = requests?.Cancel_FromDate || "";
    const cancelToStr = requests?.Cancel_ToDate || "";
    let cancelDaysCount = "";
    if (cancelFromStr && cancelToStr) {
      const fromD = new Date(cancelFromStr);
      const toD = new Date(cancelToStr);
      const diffTime = Math.abs(toD - fromD);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
      cancelDaysCount = isNaN(diffDays) ? "" : `${diffDays} Day(s)`;
    }

    detailsHtml = `
      <table style="width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 13px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold; width: 35%;">Cancellation ID</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">${requests?.Cancellation_Id || "-"}</td>
        </tr>
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold;">Original Leave ID</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">${requests?.Application_Id?.Application_Id || "-"}</td>
        </tr>
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold;">Leave Type</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">${requests?.Leavetype_Id?.Leave_Type || requests?.Leavetype || "-"}</td>
        </tr>
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold;">Cancellation Period</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">
            ${formatDate(cancelFromStr)} to ${formatDate(cancelToStr)}
            ${cancelDaysCount ? ` <span style="color: #6b7280; font-size: 12px; font-weight: normal;">(${cancelDaysCount})</span>` : ""}
          </td>
        </tr>
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold; vertical-align: top;">Reason</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937; line-height: 1.4;">${requests?.ReasonOf_Cancelation || "-"}</td>
        </tr>
      </table>
    `;
  } else if (
    workflowName === "timesheet" ||
    workflowName === "Timesheet" ||
    workflowName === "TimesheetLog" ||
    workflowName?.toLowerCase() === "timesheet"
  ) {
    const data = Array.isArray(requests) ? requests[0] : requests;
    const fromStr = data?.FromDate || data?.From_Date || "";
    const toStr = data?.ToDate || data?.To_Date || "";
    const timesheetName = data?.Timesheet_Name || "";
    const month = data?.Month || "";
    const year = data?.Year || "";
    let weekNo = data?.WeekNo || data?.Weekno || data?.weekNo || "";
    if (!weekNo && timesheetName) {
      const match = timesheetName.match(/week no (\d+)/i);
      if (match) {
        weekNo = match[1];
      }
    }

    detailsHtml = `
      <table style="width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 13px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold; width: 35%;">Timesheet ID</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">${data?.TimeSheet_Id || "-"}</td>
        </tr>
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold;">Timesheet Name</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">${timesheetName || "-"}</td>
        </tr>
        ${weekNo ? `
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold;">Week Number</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">Week ${weekNo}</td>
        </tr>
        ` : ""}
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold;">Timesheet Period</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">
            ${formatDate(fromStr)} to ${formatDate(toStr)}
          </td>
        </tr>
        ${month || year ? `
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold;">Month / Year</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">${month}${month && year ? " / " : ""}${year}</td>
        </tr>
        ` : ""}
      </table>
    `;
  } else {
    // Generic fallback for other workflows
    const requestNo = getRequestNumber(workflowName, requests);
    detailsHtml = `
      <table style="width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 13px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
        ${requestNo ? `
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold; width: 35%;">Request ID</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">${requestNo}</td>
        </tr>
        ` : ""}
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold; width: 35%;">Request Type</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">${workflowName}</td>
        </tr>
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #4b5563; font-weight: bold;">Processed Date</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #e5e7eb; color: #1f2937;">${new Date().toLocaleString()}</td>
        </tr>
      </table>
    `;
  }

  return `
  <div style="background-color: #f3f4f6; padding: 30px 15px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; min-height: 100%;">
    <div style="max-width: 580px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 10px rgba(0,0,0,0.05); border: 1px solid #e5e7eb;">
      
      <!-- Header Banner -->
      <div style="background-color: ${isApproved ? "#ecfdf5" : "#fef2f2"}; border-bottom: 3px solid ${statusColor}; padding: 30px 25px; text-align: center;">
        <div style="display: inline-block; background-color: ${isApproved ? "#d1fae5" : "#fee2e2"}; color: ${statusColor}; font-size: 12px; font-weight: bold; text-transform: uppercase; letter-spacing: 1px; padding: 6px 16px; border-radius: 20px; margin-bottom: 12px;">
          ${statusText}
        </div>
        <h2 style="margin: 0; color: #1f2937; font-size: 20px; font-weight: 700; line-height: 1.3;">
          ${workflowName} Request ${isApproved ? "Approved" : "Rejected"}
        </h2>
      </div>

      <!-- Main Body -->
      <div style="padding: 30px 25px;">
        <p style="margin-top: 0; margin-bottom: 18px; font-size: 15px; color: #1f2937; line-height: 1.5;">
          Hello <strong>${getInitiatorName(workflowName, requests) || "Employee"}</strong>,
        </p>

        <p style="margin-bottom: 24px; font-size: 15px; color: #4b5563; line-height: 1.5;">
          ${approvalMessage}
        </p>

        <!-- Request Details Panel -->
        <div style="border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden; background-color: #fafafa; margin-bottom: 24px;">
          <div style="background-color: #f3f4f6; padding: 10px 15px; border-bottom: 1px solid #e5e7eb; font-size: 11px; font-weight: bold; color: #4b5563; text-transform: uppercase; letter-spacing: 0.5px;">
            Details of your Request
          </div>
          <div style="padding: 10px 15px;">
            ${detailsHtml}
          </div>
        </div>

        <!-- Approver's Comments if available -->
        ${
          approverComments
            ? `
          <div style="margin-bottom: 24px; border-left: 4px solid ${statusColor}; padding: 12px 16px; background-color: ${isApproved ? "#f0fdf4" : "#fef2f2"}; border-radius: 0 8px 8px 0;">
            <p style="margin: 0 0 6px 0; font-size: 11px; font-weight: bold; color: ${isApproved ? "#166534" : "#991b1b"}; text-transform: uppercase; letter-spacing: 0.5px;">
              Reviewer Remarks
            </p>
            <p style="margin: 0; font-size: 14px; color: #374151; line-height: 1.4; font-style: italic;">
              "${approverComments}"
            </p>
          </div>
        `
            : ""
        }

        <!-- Informational Footer Notes -->
        <div style="border-top: 1px solid #e5e7eb; padding-top: 20px; margin-top: 10px; font-size: 13px; color: #6b7280; line-height: 1.5;">
          <p style="margin: 0 0 8px 0;">
            ${isApproved 
              ? "Your request has been successfully updated in the HR Management System. No further action is required."
              : "If you have any questions or require further clarification, please contact the HR Department."}
          </p>
          <p style="margin: 0; font-size: 11px; color: #9ca3af; font-style: italic;">
            This is an automatically generated system email. Please do not reply directly to this message.
          </p>
        </div>

      </div>

      <!-- Footer Info -->
      <div style="background-color: #f9fafb; border-top: 1px solid #e5e7eb; padding: 20px 25px; text-align: center;">
        <p style="margin: 0; font-size: 13px; color: #4b5563; font-weight: bold;">
          Regards,
        </p>
        <p style="margin: 4px 0 0 0; font-size: 13px; color: #6b7280;">
          HR Management Team
        </p>
      </div>

    </div>
  </div>
  `;
};